"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var normalizeValue = function normalizeValue(min, value, max) {
  return Math.max(Math.min(value, max), min);
};

var getStyleFabric = function getStyleFabric() {
  var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'y';
  var propName = {
    minHeight: axis === 'y' ? 'minHeight' : 'minWidth',
    height: axis === 'y' ? 'height' : 'width',
    maxHeight: axis === 'y' ? 'maxHeight' : 'maxWidth'
  };
  return function (size) {
    var _ref;

    return _ref = {}, (0, _defineProperty2.default)(_ref, propName.minHeight, size), (0, _defineProperty2.default)(_ref, propName.height, size), (0, _defineProperty2.default)(_ref, propName.maxHeight, size), (0, _defineProperty2.default)(_ref, "overflowAnchor", 'none'), (0, _defineProperty2.default)(_ref, "pointerEvents", 'none'), (0, _defineProperty2.default)(_ref, "userSelect", 'none'), (0, _defineProperty2.default)(_ref, "padding", 0), (0, _defineProperty2.default)(_ref, "margin", 0), (0, _defineProperty2.default)(_ref, "border", 'none'), _ref;
  };
};

var MIN_INDEX = 0;

var IS_OVERFLOW_ANCHOR_SUPPORTED = function () {
  try {
    return window.CSS.supports('overflow-anchor: auto');
  } catch (error) {
    return false;
  }
}();

var ViewportList = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var _ref2$viewportRef = _ref2.viewportRef,
      viewportRef = _ref2$viewportRef === void 0 ? null : _ref2$viewportRef,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      itemMinSize = _ref2.itemMinSize,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? 0 : _ref2$margin,
      _ref2$overscan = _ref2.overscan,
      overscan = _ref2$overscan === void 0 ? 1 : _ref2$overscan,
      _ref2$axis = _ref2.axis,
      axis = _ref2$axis === void 0 ? 'y' : _ref2$axis,
      _ref2$initialIndex = _ref2.initialIndex,
      initialIndex = _ref2$initialIndex === void 0 ? 0 : _ref2$initialIndex,
      _ref2$initialAlignToT = _ref2.initialAlignToTop,
      initialAlignToTop = _ref2$initialAlignToT === void 0 ? true : _ref2$initialAlignToT,
      children = _ref2.children;

  var _useMemo = (0, _react.useMemo)(function () {
    return {
      propName: {
        top: axis === 'y' ? 'top' : 'left',
        bottom: axis === 'y' ? 'bottom' : 'right',
        clientHeight: axis === 'y' ? 'clientHeight' : 'clientWidth',
        scrollTop: axis === 'y' ? 'scrollTop' : 'scrollLeft',
        overflowY: axis === 'y' ? 'overflowY' : 'overflowX'
      },
      getStyle: getStyleFabric(axis)
    };
  }, [axis]),
      propName = _useMemo.propName,
      getStyle = _useMemo.getStyle;

  var maxIndex = items.length - 1;
  var itemMinSizeWithMargin = itemMinSize + margin;
  var overscanSize = overscan * itemMinSizeWithMargin;

  var _useState = (0, _react.useState)(function () {
    var normalizedInitialIndex = normalizeValue(MIN_INDEX, initialIndex, maxIndex);
    return [normalizedInitialIndex, normalizedInitialIndex];
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      _useState2$ = (0, _slicedToArray2.default)(_useState2[0], 2),
      startIndex = _useState2$[0],
      endIndex = _useState2$[1],
      setIndexes = _useState2[1];

  var topRef = (0, _react.useRef)(null);
  var bottomRef = (0, _react.useRef)(null);
  var variables = (0, _react.useRef)({
    cache: [],
    step: function step() {},
    scrollToIndex: startIndex ? {
      index: startIndex,
      alignToTop: initialAlignToTop
    } : null,
    scrollCompensationEndIndex: null
  });
  var normalizedStartIndex = normalizeValue(MIN_INDEX, startIndex, maxIndex);
  var normalizedEndIndex = normalizeValue(normalizedStartIndex, endIndex, maxIndex);
  var topStyle = (0, _react.useMemo)(function () {
    return getStyle(variables.current.cache.slice(MIN_INDEX, normalizedStartIndex).reduce(function (sum, next) {
      return sum + next;
    }, normalizedStartIndex * itemMinSizeWithMargin));
  }, [normalizedStartIndex, itemMinSizeWithMargin, getStyle]);
  var bottomStyle = (0, _react.useMemo)(function () {
    return getStyle(variables.current.cache.slice(normalizedEndIndex + 1, maxIndex).reduce(function (sum, next) {
      return sum + next;
    }, itemMinSizeWithMargin * (maxIndex - normalizedEndIndex)));
  }, [normalizedEndIndex, maxIndex, itemMinSizeWithMargin, getStyle]);
  var slicedItems = (0, _react.useMemo)(function () {
    return items.slice(normalizedStartIndex, normalizedEndIndex + 1).map(function (item, index) {
      return children(item, normalizedStartIndex + index);
    });
  }, [items, normalizedStartIndex, normalizedEndIndex, children]);

  variables.current.step = function () {
    var viewportRect = viewportRef && viewportRef.current && viewportRef.current.getBoundingClientRect();
    var topLimit = (viewportRect ? normalizeValue(0, viewportRect[propName.top], document.documentElement[propName.clientHeight]) : 0) - overscanSize;
    var bottomLimit = (viewportRect ? normalizeValue(0, viewportRect[propName.bottom], document.documentElement[propName.clientHeight]) : document.documentElement[propName.clientHeight]) + overscanSize;
    var topElementRect = topRef.current.nextSibling.getBoundingClientRect();
    var bottomElementRect = bottomRef.current.previousSibling.getBoundingClientRect();
    var maxItemsCountInViewPort = Math.ceil((bottomLimit - topLimit) / itemMinSizeWithMargin);
    var nextStartIndex = startIndex;
    var nextEndIndex = endIndex;
    var diff;
    var index;
    var element;

    if (variables.current.scrollToIndex) {
      var targetIndex = normalizeValue(MIN_INDEX, variables.current.scrollToIndex.index, maxIndex);

      if (targetIndex >= startIndex && targetIndex <= endIndex) {
        index = startIndex;
        element = topRef.current.nextSibling;

        while (element !== bottomRef.current) {
          if (index === targetIndex) {
            element.scrollIntoView(variables.current.scrollToIndex.alignToTop);
            variables.current.scrollToIndex = null;
            break;
          }

          element = element.nextSibling;
          ++index;
        }

        return;
      }

      nextStartIndex = targetIndex - maxItemsCountInViewPort;
      nextEndIndex = targetIndex + maxItemsCountInViewPort;
    } else if (topElementRect[propName.top] >= bottomLimit) {
      diff = topElementRect[propName.top] - bottomLimit;
      nextEndIndex = startIndex;

      while (diff >= 0 && nextEndIndex > MIN_INDEX) {
        diff -= (variables.current.cache[--nextEndIndex] || 0) + itemMinSizeWithMargin;
      }

      variables.current.scrollCompensationEndIndex = startIndex;
      nextStartIndex = nextEndIndex - maxItemsCountInViewPort;
    } else if (bottomElementRect[propName.bottom] + margin <= topLimit) {
      diff = topLimit - bottomElementRect[propName.bottom] + margin;
      nextStartIndex = endIndex;

      while (diff >= 0 && nextStartIndex < maxIndex) {
        diff -= (variables.current.cache[++nextStartIndex] || 0) + itemMinSizeWithMargin;
      }

      nextEndIndex = nextStartIndex + maxItemsCountInViewPort;
    } else {
      if (topElementRect[propName.bottom] + margin < topLimit) {
        ++nextStartIndex;
      } else if (topElementRect[propName.top] >= topLimit) {
        diff = topElementRect[propName.top] - topLimit;

        while (diff >= 0 && nextStartIndex > MIN_INDEX) {
          diff -= (variables.current.cache[--nextStartIndex] || 0) + itemMinSizeWithMargin;
        }

        variables.current.scrollCompensationEndIndex = startIndex;
      }

      if (bottomElementRect[propName.bottom] + margin <= bottomLimit) {
        diff = bottomLimit - bottomElementRect[propName.bottom] - margin;

        while (diff >= 0 && nextEndIndex < maxIndex) {
          diff -= (variables.current.cache[++nextEndIndex] || 0) + itemMinSizeWithMargin;
        }
      } else if (bottomElementRect[propName.top] > bottomLimit) {
        --nextEndIndex;
      }
    }

    nextStartIndex = normalizeValue(MIN_INDEX, nextStartIndex, maxIndex);
    nextEndIndex = normalizeValue(nextStartIndex, nextEndIndex, maxIndex);

    if (nextStartIndex !== startIndex || nextEndIndex !== endIndex) {
      index = startIndex;
      element = topRef.current.nextSibling;

      while (index <= endIndex && element !== bottomRef.current) {
        variables.current.cache[index++] = element[propName.clientHeight] - itemMinSize;
        element = element.nextSibling;
      }

      setIndexes([nextStartIndex, nextEndIndex]);
    }
  };

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      scrollToIndex: function scrollToIndex() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var alignToTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        variables.current.scrollToIndex = {
          index: index,
          alignToTop: alignToTop
        };
      }
    };
  }, []);
  (0, _react.useLayoutEffect)(function () {
    if (variables.current.scrollCompensationEndIndex === null) {
      return;
    }

    if (!viewportRef || IS_OVERFLOW_ANCHOR_SUPPORTED) {
      variables.current.scrollCompensationEndIndex = null;
      return;
    }

    var index = startIndex;
    var element = topRef.current.nextSibling;
    var sizeDiff = 0;

    while (index < variables.current.scrollCompensationEndIndex && element !== bottomRef.current) {
      sizeDiff += element[propName.clientHeight] - (variables.current.cache[index] || 0) - itemMinSize;
      element = element.nextSibling;
      ++index;
    }

    if (viewportRef && sizeDiff) {
      viewportRef.current.style[propName.overflowY] = 'hidden';
      viewportRef.current[propName.scrollTop] += sizeDiff;
      viewportRef.current.style[propName.overflowY] = null;
    }

    variables.current.scrollCompensationEndIndex = null;
  }, [viewportRef, startIndex, itemMinSize, propName]);
  (0, _react.useEffect)(function () {
    var frameId = null;

    var frame = function frame() {
      frameId = requestAnimationFrame(frame);
      variables.current.step();
    };

    frame();
    return function () {
      return cancelAnimationFrame(frameId);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: "ViewPortList"
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "ViewPortListTop",
    ref: topRef,
    style: topStyle
  }), slicedItems, /*#__PURE__*/_react.default.createElement("div", {
    key: "ViewPortListBottom",
    ref: bottomRef,
    style: bottomStyle
  }));
});

var _default = ViewportList;
exports.default = _default;